import { appConfig } from "../configs/appConfig";
import { Status } from "../types/status";

interface ISignIn {
  props: {
    email: string;
    password: string;
  };
  res: {
    status: Status;
    data: {
      message: string;
    };
  };
}

interface ILogout {
  props: {};
  res: {
    status: Status;
    data: {
      message: string;
    };
  };
}

class AuthService {
  async signIn(props: ISignIn["props"]): Promise<ISignIn["res"]> {
    const res = await fetch(appConfig.apiUrl + "/signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...props }),
      credentials: "include",
    });

    const json = await res.json();

    return json;
  }

  async logout(): Promise<ILogout["res"]> {
    const res = await fetch(appConfig.apiUrl + "/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    const json = await res.json();

    return json;
  }
}

export default new AuthService();
